import {createSelector} from 'reselect';

export const getSaveResponse = state =>
  state.saveResponse && state.saveResponse.get('response');

export const getSaveErrors = state =>
  state.saveResponse && state.saveResponse.get('errors');

export const emailSent = state =>
  !!state.saveResponse && state.saveResponse.get('emailSent');

export const hasSaveResponse = createSelector(
  [getSaveResponse],
  saveResponse => !!saveResponse
);

export const getDesignId = createSelector(
  [getSaveResponse],
  saveResponse => saveResponse && saveResponse.design.designid
);

export const getSavedEmail = createSelector([getSaveResponse], saveResponse => {
  return saveResponse ? saveResponse.design.account_email : null;
});
